import { breakpoints } from 'ui/acro'

export const EVENTS_CAROUSEL_BREAKPOINTS = {
  0: {
    slidesPerView: 1.2,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16
  },
  320: {
    slidesPerView: 1.4,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16
  },
  375: {
    slidesPerView: 1.7,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16
  },
  [breakpoints[1]]: {
    slidesPerView: 2.4,
    spaceBetween: 20,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16
  },
  768: {
    slidesPerView: 2.6,
    spaceBetween: 20,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16
  },
  [breakpoints[2]]: {
    slidesPerView: 3,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0
  }
}
